import { z } from "zod";

export const uuid = z.string().uuid();

export const Address = z.object({
  street: z.string().max(200).nullable().optional(),
  street2: z.string().max(200).nullable().optional(),
  city: z.string().max(120).nullable().optional(),
  state: z.string().max(120).nullable().optional(),
  postalCode: z.string().max(40).nullable().optional(),
  country: z.string().max(80).nullable().optional(),
  placeId: z.string().max(200).nullable().optional(),
  lat: z.number().nullable().optional(),
  lng: z.number().nullable().optional(),
});
export type Address = z.infer<typeof Address>;

export function formatAddress(a: Address | null | undefined): string {
  if (!a) return "";
  const cityState = [a.city, a.state].filter(Boolean).join(", ");
  return [a.street, a.street2, cityState, a.postalCode, a.country]
    .filter((x) => x && String(x).trim())
    .join(", ");
}

export const Money = z.coerce.number().min(0).max(99_999_999.99);
export const DateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Use YYYY-MM-DD");
export const TimeOnly = z.string().regex(/^\d{2}:\d{2}$/, "Use HH:MM");
